import PropTypes from 'prop-types';
import React from 'react';

function ThirdPartyScriptLoader({ children }) {
  // need this so that JSX compiler knows to return JSX and not just children in raw form
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}

ThirdPartyScriptLoader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default ThirdPartyScriptLoader;
